var _ellipse, _ellipse2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExemptionsMoreWaysToSave = function SvgExemptionsMoreWaysToSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.466,
    cy: 36.674,
    rx: 36.153,
    ry: 36.097,
    fill: "#EDF6FF",
    fillOpacity: 0.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.466,
    cy: 36.674,
    rx: 28.922,
    ry: 28.878,
    fill: "#D5EAFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#exemptions-more-ways-to-save_svg__a)",
    fill: "#1A5CA3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.466 18.625c-5.582 0-10.123 4.534-10.123 10.107v4.949c0 .337.274.61.612.61h3.393a.61.61 0 0 0 .611-.61v-4.949c0-3.031 2.47-5.498 5.506-5.498 3.037 0 5.507 2.467 5.507 5.498v4.949c0 .337.274.61.611.61h3.394a.61.61 0 0 0 .61-.61v-4.949c0-5.573-4.54-10.107-10.121-10.107Zm8.9 14.446h-2.172v-4.339c0-3.704-3.018-6.718-6.728-6.718s-6.729 3.014-6.729 6.718v4.339h-2.171v-4.339c0-4.9 3.992-8.886 8.9-8.886 4.907 0 8.9 3.986 8.9 8.886v4.339Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.384 33.07H25.547a2.627 2.627 0 0 0-2.626 2.623V52.1a2.627 2.627 0 0 0 2.626 2.622h21.837a2.627 2.627 0 0 0 2.625-2.622V35.693a2.627 2.627 0 0 0-2.625-2.622Zm1.403 19.03c0 .773-.63 1.402-1.403 1.402H25.547a1.404 1.404 0 0 1-1.404-1.401V35.693c0-.773.63-1.402 1.404-1.402h21.837c.773 0 1.403.629 1.403 1.402V52.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.522 44.696a3.156 3.156 0 0 0 1.13-2.423 3.186 3.186 0 0 0-6.37 0c0 .944.415 1.822 1.129 2.423l-.687 3.269a.61.61 0 0 0 .598.735h4.289a.611.611 0 0 0 .598-.735l-.687-3.27Zm-1.007-.773a.61.61 0 0 0-.27.64l.613 2.917h-2.783l.613-2.916a.61.61 0 0 0-.27-.64 1.95 1.95 0 0 1-.914-1.65 1.963 1.963 0 0 1 3.925 0c0 .669-.342 1.285-.914 1.65Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "exemptions-more-ways-to-save_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(18.39 18.625)",
    d: "M0 0h36.153v36.097H0z"
  })))));
};
export default SvgExemptionsMoreWaysToSave;